/**
 * @generated SignedSource<<380954aeefb1187541732b7b52d6f2a3>>
 * @relayHash 74c35ccc658af4208bb4e7988e279e32
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/362.0.0-2022-04-26T08:27:46.271Z/holdRequestMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TimeUnitType = "DAY" | "BUSINESS_DAY" | "MINUTE" | "%future added value";
export type CreateHoldRequestInput = {
  itemId?: string | null;
  userId?: string | null;
  sellerId?: string | null;
  vertical?: string | null;
  duration?: number | null;
  timeUnit?: TimeUnitType | null;
  clientMutationId?: string | null;
};
export type holdRequestMutation$variables = {
  input: CreateHoldRequestInput;
  userId: string;
};
export type holdRequestMutation$data = {
  readonly createHoldRequest: {
    readonly item: {
      readonly isOnHold: boolean | null;
      readonly hasRequestedHoldForBuyer: boolean | null;
      readonly relevantHoldForBuyer: {
        readonly isRequested: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type holdRequestMutation = {
  variables: holdRequestMutation$variables;
  response: holdRequestMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnHold",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "userId"
  }
],
v4 = {
  "alias": null,
  "args": (v3/*: any*/),
  "kind": "ScalarField",
  "name": "hasRequestedHoldForBuyer",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRequested",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "holdRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateHoldRequestPayload",
        "kind": "LinkedField",
        "name": "createHoldRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Item",
            "kind": "LinkedField",
            "name": "item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "Hold",
                "kind": "LinkedField",
                "name": "relevantHoldForBuyer",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "holdRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateHoldRequestPayload",
        "kind": "LinkedField",
        "name": "createHoldRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Item",
            "kind": "LinkedField",
            "name": "item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "Hold",
                "kind": "LinkedField",
                "name": "relevantHoldForBuyer",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/362.0.0-2022-04-26T08:27:46.271Z/holdRequestMutation",
    "metadata": {},
    "name": "holdRequestMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e3373454beb2c0ca06dab030fec8c47f";

export default node;
